import { useMutation } from '@apollo/client';
import { CONFIRM_MOBILE_NUMBER } from './confirmMobileNumber.graphql';
import { omitDeep } from 'utils';

const useConfirmMobileNumber = () => {
  const [confirmMobileNumberExists] = useMutation(CONFIRM_MOBILE_NUMBER);

  return input => {
    return confirmMobileNumberExists({
      variables: omitDeep(
        {
          mobileNumber: input.mobileNumber,
          userId: input.userId,
        },
        ['__typename']
      ),
    });
  };
};

export default useConfirmMobileNumber;
